var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixRiseV1WalletAction from '@wix/ambassador-rise-v1-wallet-action/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var WalletActionType;
(function (WalletActionType) {
    WalletActionType["UNKNOWN"] = "UNKNOWN";
    WalletActionType["REWARD"] = "REWARD";
    WalletActionType["REFUND"] = "REFUND";
})(WalletActionType || (WalletActionType = {}));
export var WalletActionStatus;
(function (WalletActionStatus) {
    WalletActionStatus["PENDING"] = "PENDING";
    WalletActionStatus["ACTIVE"] = "ACTIVE";
    WalletActionStatus["DISABLED"] = "DISABLED";
    WalletActionStatus["EXPIRED"] = "EXPIRED";
})(WalletActionStatus || (WalletActionStatus = {}));
export var InitiatorType;
(function (InitiatorType) {
    InitiatorType["UNKNOWN_INITIATOR"] = "UNKNOWN_INITIATOR";
    InitiatorType["APP"] = "APP";
    InitiatorType["USER"] = "USER";
})(InitiatorType || (InitiatorType = {}));
export var StoreCreditIssuerType;
(function (StoreCreditIssuerType) {
    StoreCreditIssuerType["UNKNOWN_ISSUER"] = "UNKNOWN_ISSUER";
    StoreCreditIssuerType["WORKFLOW"] = "WORKFLOW";
    StoreCreditIssuerType["BULK"] = "BULK";
    StoreCreditIssuerType["MANUAL"] = "MANUAL";
    StoreCreditIssuerType["OTHER"] = "OTHER";
    StoreCreditIssuerType["REFUND"] = "REFUND";
})(StoreCreditIssuerType || (StoreCreditIssuerType = {}));
export var ExternalEventType;
(function (ExternalEventType) {
    ExternalEventType["UNKNOWN_EVENT_TYPE"] = "UNKNOWN_EVENT_TYPE";
    ExternalEventType["ORDER"] = "ORDER";
    ExternalEventType["REFUND"] = "REFUND";
    ExternalEventType["REFERRAL"] = "REFERRAL";
    ExternalEventType["SIGN_UP"] = "SIGN_UP";
    ExternalEventType["MEMBERSHIP"] = "MEMBERSHIP";
    ExternalEventType["COMPENSATION"] = "COMPENSATION";
    ExternalEventType["OTHER"] = "OTHER";
})(ExternalEventType || (ExternalEventType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _createWalletActionByCustomerReferenceRequest = {};
const _createWalletActionByCustomerReferenceResponse = {};
const _createWalletActionRequest = {};
const _createWalletActionResponse = {};
const _deleteWalletActionRequest = {};
const _deleteWalletActionResponse = {};
const _disableWalletActionRequest = {};
const _disableWalletActionResponse = {};
const _getWalletActionRequest = {};
const _getWalletActionResponse = {};
const _queryWalletActionBalancesRequest = {};
const _queryWalletActionBalancesResponse = {};
const _queryWalletActionRequest = {};
const _queryWalletActionResponse = {};
const _updateWalletActionRequest = {};
const _updateWalletActionResponse = {};
/**
 * Creates a new WalletAction
 * @param walletAction - WalletAction to be created
 * @public
 * @documentationMaturity preview
 * @requiredField walletAction
 * @requiredField walletAction.amount
 * @requiredField walletAction.walletId
 * @adminMethod
 * @returns The created WalletAction
 */
export function createWalletAction(walletAction) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { walletAction: '$[0]' };
        const responseTransformation = '$.walletAction';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createWalletActionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createWalletActionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([walletAction]);
        const reqOpts = ambassadorWixRiseV1WalletAction.createWalletAction(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'walletAction',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param customerReference - CustomerReference to create WalletAction for
 * @public
 * @documentationMaturity preview
 * @requiredField customerReference
 * @requiredField customerReference.email
 * @requiredField customerReference.sourceChannelId
 * @requiredField customerReference.sourceCustomerId
 * @requiredField customerReference.sourceTenantId
 * @requiredField options.walletAction
 * @requiredField options.walletAction.amount
 * @adminMethod
 */
export function createWalletActionByCustomerReference(customerReference, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            customerReference: '$[0]',
            walletAction: '$[1].walletAction',
            newWalletCurrency: '$[1].newWalletCurrency',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createWalletActionByCustomerReferenceRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createWalletActionByCustomerReferenceResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([customerReference, options]);
        const reqOpts = ambassadorWixRiseV1WalletAction.createWalletActionByCustomerReference(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'customerReference',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get an WalletAction by ID
 * @param walletActionId - ID of the WalletAction to retrieve
 * @public
 * @documentationMaturity preview
 * @requiredField walletActionId
 * @adminMethod
 * @returns The retrieved WalletAction
 */
export function getWalletAction(walletActionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { walletActionId: '$[0]' };
        const responseTransformation = '$.walletAction';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getWalletActionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getWalletActionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([walletActionId]);
        const reqOpts = ambassadorWixRiseV1WalletAction.getWalletAction(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'walletActionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update an WalletAction, supports partial update
 * Pass the latest `revision` for a successful update
 * @param _id - WalletAction ID
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField walletAction
 * @requiredField walletAction.revision
 * @adminMethod
 * @returns The updated WalletAction
 */
export function updateWalletAction(_id, walletAction, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            walletAction: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
        };
        const responseTransformation = '$.walletAction';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateWalletActionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateWalletActionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, walletAction, options]);
        const reqOpts = ambassadorWixRiseV1WalletAction.updateWalletAction(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'walletAction',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Expire an WalletAction immediately and deducting the remaining balance from the gift card
 * @param walletActionId - ID of the WalletAction to delete
 * @param revision - The revision of the WalletAction
 * @public
 * @documentationMaturity preview
 * @requiredField revision
 * @requiredField walletActionId
 * @adminMethod
 */
export function disableWalletAction(walletActionId, revision) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { walletActionId: '$[0]', revision: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _disableWalletActionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _disableWalletActionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['walletAction']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([walletActionId, revision]);
        const reqOpts = ambassadorWixRiseV1WalletAction.disableWalletAction(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'walletActionId',
                'revision',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Delete an WalletAction, only available for wallet_actions which haven't started
 * @param walletActionId - ID of the WalletAction to delete
 * @internal
 * @documentationMaturity preview
 * @requiredField walletActionId
 * @adminMethod
 */
export function deleteWalletAction(walletActionId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            walletActionId: '$[0]',
            revision: '$[1].revision',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteWalletActionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteWalletActionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([walletActionId, options]);
        const reqOpts = ambassadorWixRiseV1WalletAction.deleteWalletAction(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'walletActionId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Query WalletActions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
 * @public
 * @documentationMaturity preview
 * @permissionId RISE.WALLET_ACTION_READ
 * @adminMethod
 */
export function queryWalletActions() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.walletActions',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryWalletActionRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryWalletActionResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#walletActions']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixRiseV1WalletAction.queryWalletActions(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Query WalletActions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
 * Results will be enriched with calculated balances
 * @param query - WQL expression
 * @public
 * @documentationMaturity preview
 * @requiredField query
 * @adminMethod
 */
export function queryWalletActionsBalances(query) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryWalletActionBalancesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryWalletActionBalancesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#walletActions.walletAction']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([query]);
        const reqOpts = ambassadorWixRiseV1WalletAction.queryWalletActionsBalances(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'query',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=rise-v1-wallet-action.universal.js.map